module.exports = __webpack_public_path__ + "img/carbon_delivery.71c929bf.svg";